import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";

export function VehicleInspectionsTab({ vehicleId }) {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get(`/vehicles/${vehicleId}/inspections`)
      .then((r) => setItems(r.data.items || []))
      .catch(() => setItems([]));
  }, [vehicleId]);
  if (items === null) return <div className="text-sm text-slate-500 p-6">Loading…</div>;
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-6" data-testid="vd-inspections">
      <h2 className="font-display text-lg font-semibold">Inspections</h2>
      <p className="text-xs text-slate-500 mt-0.5">
        Pickup and return inspections completed against this vehicle.
        Start a new inspection from the relevant booking: that&apos;s where the customer + odometer + fuel context lives.
      </p>
      {items.length === 0 ? (
        <div className="mt-4 text-sm text-slate-500" data-testid="vd-inspections-empty">
          No inspections recorded for this vehicle yet.
        </div>
      ) : (
        <ul className="mt-4 divide-y divide-slate-100">
          {items.map((i) => (
            <li key={i.id} className="py-3 flex items-center justify-between gap-3" data-testid={`vd-insp-${i.id}`}>
              <div className="min-w-0">
                <div className="font-medium capitalize">{(i.kind || i.type || "inspection").replace(/_/g, " ")}</div>
                <div className="text-xs text-slate-500">
                  {i.booking ? (
                    <Link to={`/app/bookings/${i.booking.id}`} className="hover:underline">
                      {i.booking.booking_ref || i.booking.id.slice(0, 8)}: {i.booking.customer_name}
                    </Link>
                  ) : "-"}
                  <span className="ml-2 text-slate-400">{i.created_at ? new Date(i.created_at).toLocaleDateString() : ""}</span>
                </div>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                {i.has_damage && (
                  <span className="text-[11px] px-2 py-0.5 rounded-full bg-red-50 border border-red-200 text-red-700">
                    Damage found
                  </span>
                )}
                <span className={`text-[11px] px-2 py-0.5 rounded-full border whitespace-nowrap ${
                  i.status === "final" || i.finalized_at
                    ? "bg-emerald-50 border-emerald-200 text-emerald-800"
                    : "bg-amber-50 border-amber-200 text-amber-800"
                }`}>
                  {i.status === "final" || i.finalized_at ? "Final" : "Draft"}
                </span>
                <Link
                  to={`/app/inspections/${i.id}`}
                  className="text-xs text-emerald-700 hover:underline"
                  data-testid={`vd-insp-${i.id}-open`}
                >
                  Open →
                </Link>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
